import React, { ReactElement } from 'react';
import styled, { keyframes } from 'styled-components';

const animateInLeft = keyframes`
  0% {
    transform: translateX(-100%);
  }
  90% {
    transform: translateX(1%);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
`;

const animateInRight = keyframes`
  0% {
    transform: translateX(100%);
  }
  90% {
    transform: translateX(-1%);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
`;

const Container = styled.div`
  position: relative;
  z-index: 1;
`;

type ItemProps = {
  index: number
  position: 'left' | 'right'
}

const Item = styled.div`
  animation: ${({ position }: ItemProps) => position === 'left' ? animateInLeft : animateInRight} 750ms;
  animation-delay: ${({ index }: ItemProps) => index * 120}ms;
  animation-fill-mode: both;
  animation-timing-function: ease-in-out;
  transition: background-color 1000ms ease-in;
`;

type Props = {
  items: ReactElement[]
  position: 'left' | 'right'
}

const Menu = ({ items, position }: Props) => {
  return(
    <Container>
      { 
        items.map((item, index) => {
          return <Item key={index} index={index} position={position}>{ item }</Item>
        })
      }
    </Container>
  );
};

export default Menu;